// ==========================
// Version 2: pages/LandingPage3.js
// - Main public landing page at "/"
// - Adds an enhanced sample-memory card treatment without changing its content
// ==========================
import React from "react";
import LandingPage2 from "./LandingPage2";

export default function LandingPage3() {
  return <LandingPage2 enhancedMemoryCard pagePath="/" />;
}
